import React from "react";
import NewsSection from "./sections/NewsSection.jsx";
import VideoSection from "./sections/VideoSection.jsx";
import QuickLinks from "../layouts/components/QuickLinks.jsx";
import PhotoWeek from "../layouts/components/PhotoWeek.jsx";
import Sidebar from "../layouts/components/Sidebar.jsx";
import GalleryViewer from "./sections/GalleryViewer.jsx";
import BriefsQuick from "./sections/BriefsQuick.jsx";
import DirectorsSlider from "../layouts/components/DirectorsSlider.jsx";
import EventQuick from "./sections/EventQuick.jsx";

const HomeScreen = () => {
  return (
    <div>
      <div className="container">
        <Sidebar />

        <main className="main-content">
          <NewsSection />
          <VideoSection />
        </main>

        <aside className="right-sidebar">
          <DirectorsSlider />
          <BriefsQuick />
          <EventQuick />
          <QuickLinks />
          {/* <PhotoWeek /> */}
        </aside>
      </div>
    </div>
  );
};

export default HomeScreen;
